import { buildStyleFns } from '../buildStyleFns';
export var borderShorthandStyleFnConfigs = [
    {
        name: 'border',
        properties: ['border'],
        system: 'none',
    },
    {
        name: 'borderTop',
        properties: ['borderTop'],
        system: 'none',
    },
    {
        name: 'borderRight',
        properties: ['borderRight'],
        system: 'none',
    },
    {
        name: 'borderBottom',
        properties: ['borderBottom'],
        system: 'none',
    },
    {
        name: 'borderLeft',
        properties: ['borderLeft'],
        system: 'none',
    },
    {
        name: 'borderInlineStart',
        properties: ['borderInlineStart'],
        system: 'none',
    },
    {
        name: 'borderInlineEnd',
        properties: ['borderInlineEnd'],
        system: 'none',
    },
];
export var borderShorthandFns = buildStyleFns(borderShorthandStyleFnConfigs);
